module.exports = __webpack_public_path__ + "static/media/icon_msg.c678ce9c.svg";